import { configureStore } from "@reduxjs/toolkit";
import LoginReducer from "../Feature/Login/LoginSlice";

const store = configureStore({
    reducer: {
        Login: LoginReducer,
    }
})

export default store;